<!--div class="view-component-title">Busca de Categorias</div-->
<div class="content">
    <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='melisearchcategory'>
    </ngx-spinner>
    <breadcrumb #stepper [header]="header" (headerClicked)="headerClicked($event)">
        <cdk-step>
            <ul>
                <li *ngFor="let item of rootLevelNodes" (click)="selectItem(item)">
                    <div class="data-item">
                        <span class="data-item-ul">{{item.id}} - {{item.name}}</span>
                    </div>
                </li>
            </ul>
        </cdk-step> 
        <cdk-step  *ngFor="let item of steps">
            <ng-container  [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:item}"></ng-container>
        </cdk-step>
        
    </breadcrumb>
    
</div>

<ng-template #main let-item>
    <div *ngIf="(currentStep | async)?.data?.id != null">
        <div class="title" (click)="selectData(item)">{{currentData?.data?.id}} - {{currentData?.data?.name}}</div>
        <div class="setting">
            <div class="left">
                <div class="subtitle">Características</div>
                <ul>
                    <li><b>Catálogo:</b> {{currentData.data['settings']['catalog_domain']}}</li>
                    <li><b>Condição:</b> {{currentData.data['settings']['item_conditions']}}</li>
                    <li><b>Tipo de Compra:</b> {{currentData.data['settings']['buying_modes']}}</li>
                    <li><b>Tipo de Entrega:</b> {{currentData.data['settings']['shipping_modes']}}</li>
                    <li><b>Tipo de Atributo:</b> {{currentData.data['attribute_types']}}</li>
                </ul>
            </div>
        </div>
    </div>
    <div *ngIf="(currentStep | async)?.data?.children_categories?.length > 0" >
        
        <div class="subtitle">Categorias Filhas</div>
        <ul>
            <li *ngFor="let item of currentData.data['children_categories']" (click)="selectItem(item)">
                <div class="data-item">
                    <span class="data-item-ul">{{item.id}} - {{item.name}} - Total de Itens: {{item.total_items_in_this_category}}</span>
                </div>
            </li>
        </ul>
    </div>
</ng-template>